import { ENVIRONMENTAL_VARIABLES } from './Environment';

export const getAuthProvider = () => ENVIRONMENTAL_VARIABLES.AUTH_PROVIDER;
export const isKeycloak = () => 'keycloak' === getAuthProvider();
export const isAuth0 = () => 'auth0' === getAuthProvider();
